export default function News(){
    return(
        <h1>News</h1>
    );
}